import { ReactNode } from 'react';
import { AuthFooter } from './AuthFooter';

interface AuthLayoutProps {
  children: ReactNode;
}

export const AuthLayout = ({ children }: AuthLayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 flex items-center justify-center px-4">{children}</div>
      <AuthFooter />
    </div>
  );
};
